import { ref } from 'vue'
import { Dayjs } from 'dayjs'
import dayjs from 'dayjs'

export function useLastFetched(seconds: number) {
  const lastFetched = ref<Dayjs>()

  function updateLastFetched() {
    if (seconds > 0) {
      if (hasTimePassed()) {
        update()
      }
    } else {
      update()
    }
  }

  function hasTimePassed() {
    return (
      !lastFetched.value ||
      dayjs().diff(lastFetched.value, 'seconds') >= seconds
    )
  }

  function update() {
    lastFetched.value = dayjs()
  }

  return {
    lastFetched,
    updateLastFetched,
    hasTimePassed
  }
}
